// extracted by mini-css-extract-plugin
export default {"popoverContentWrapper":"ZVXCXMJ_IhMd1xN8XSQW","planWithPeriods":"G5f17NCgFccOpkvSYn2L","wrapper":"j4vFOx4hmL8W7cZ_WEFK","plansCountTag":"Vpo_kdFXQVkPHfkVHTPZ"};